// Session token storage utility
// Separate file to avoid circular dependencies

const SESSION_TOKEN_KEY = 'pen_peptido_session_token';

export const getSessionToken = () => {
  return localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setSessionToken = (token) => {
  if (token) {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }
};

export const clearSessionToken = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
};

export { SESSION_TOKEN_KEY };
